import styled from 'styled-components'

import _Button from '~/components/button'
import { device } from '~/styles/utils'

export const Actions = styled.div`
  display: flex;
  flex-direction: row-reverse;
  gap: 16px;
`

export const Button = styled(_Button)`
  flex: 1;

  @media ${device('notMobile')} {
    flex: 0;
  }
`
